export default __webpack_public_path__ + "static/media/white-logo.8b90bd8f.png";